import { useSelector } from "react-redux";
import { useGetOrdersQuery } from "../../orderApi/orderApi";
import { useGetProductsQuery } from "../../productApi/productAPI";
import { RootState } from "../store";
import { useGetAccommodationsQuery } from "../travelSlice/accommodationApi";
import { useGetBusesQuery } from "../travelSlice/busApi";
import { useGetCarsQuery } from "../travelSlice/carApi";
import { useGetFlightsQuery } from "../travelSlice/flightApi";
import { useAppSelector } from "./hooks";

export const useCombinedStore = () => {
  // 🔧 Regular reducers
  const cart = useAppSelector((state) => state.cart);
  const flightCart = useAppSelector((state) => state.flightCart);
  const flight = useAppSelector((state) => state.flight);

  // 🔧 RTK Query data (auto-fetches from API)
  const { data: flights = [], ...flightsMeta } = useGetFlightsQuery();
  const { data: cars = [], ...carsMeta } = useGetCarsQuery();
  const { data: buses = [], ...busesMeta } = useGetBusesQuery();
  const { data: accommodations = [], ...accommodationsMeta } =
    useGetAccommodationsQuery();

  const { data: products = [], ...productsMeta } = useGetProductsQuery();
  const { data: orders = [], ...ordersMeta } = useGetOrdersQuery();
  //const { data: amadeusOffers = [], ...amadeusMeta } = useGetAmadeusOffersQuery();

  return {
    // Reducer state
    cart,
    flightCart,
    flight,

    // API data (safely defaulted)
    flights,
    cars,
    buses,
    accommodations,
    products,
    orders,
    //amadeusOffers,

    // (Optional) Raw metadata if you want access to loading/error states
    _meta: {
      flights: flightsMeta,
      cars: carsMeta,
      buses: busesMeta,
      accommodations: accommodationsMeta,
      products: productsMeta,
      orders: ordersMeta,
      //amadeus: amadeusMeta,
    },

    // 👇 THESE TWO ARE CRITICAL
    hikeTrips: useSelector((state: RootState) => state.hikeTrips.list),
    hikeCars: useSelector((state: RootState) => state.hikeCars.list),
  };
};
